export default "__VITE_ASSET__f3a31117__"